import React from 'react';
import { FaBuilding, FaHardHat, FaTools, FaChartLine, FaPencilRuler, FaHandshake, FaTruckMoving, FaLeaf } from 'react-icons/fa';
import './Services.css';

const Services = () => {
  return (
    <div className="services-page">
      {/* Page Header */}
      <div className="page-headerServices">
        <div className="container">
          <h1>Our Services</h1>
          <p>Comprehensive construction solutions tailored to your needs</p>
        </div>
      </div>
      
      {/* Services Introduction */}
      <section className="section services-intro">
        <div className="container">
          <div className="intro-content">
            <h2 className="section-title">What We Offer</h2>
            <p>
              At Preferbuild, we offer a comprehensive range of construction services designed to meet the diverse needs of our clients. From residential construction to commercial building, renovation to project management, our team of skilled professionals ensures excellence in every project.
            </p>
            <p>
              We pride ourselves on our attention to detail, quality craftsmanship, and commitment to delivering projects on time and within budget. Our client-centered approach means that we work closely with you throughout the process, ensuring that your vision becomes reality.
            </p>
          </div>
        </div>
      </section>
      
      {/* Main Services */}
      <section className="section main-services">
        <div className="container">
          <h2 className="section-title">Our Core Services</h2>
          <div className="services-grid">
            <div className="service-box">
              <div className="service-icon">
                <FaBuilding />
              </div>
              <h3>Residential Construction</h3>
              <p>
                From custom homes to apartment complexes, we bring your residential vision to life with attention to detail and quality craftsmanship.
              </p>
              <ul className="service-features">
                <li>Elevations and Designer Elements</li>
                <li>Domestic Tanks & STPs</li>
                <li>Canopy & Shades</li>
                <li>Pergolas & Domes</li>
                <li>Low Cost Housing</li>
              </ul>
            </div>
            
            <div className="service-box">
              <div className="service-icon">
                <FaHardHat />
              </div>
              <h3>Commercial Building</h3>
              <p>
                Our commercial construction services deliver functional, modern, and efficient spaces for businesses of all sizes.
              </p>
              <ul className="service-features">
                <li>Pontoons & Boats</li>
                <li>Roofing & Chajjas</li>
                <li>Designer Green Buildings</li>
                <li>Sanitation Projects</li>
                <li>Water Bodies & Pools</li>
                <li>Domes</li>
              </ul>
            </div>
            
            <div className="service-box">
              <div className="service-icon">
                <FaTools />
              </div>
              <h3>Renovation & Remodeling</h3>
              <p>
                Transform your existing spaces with our expert renovation and remodeling services, breathing new life into older structures.
              </p>
              <ul className="service-features">
                <li>Rainwater Harvesting</li>
                <li>Leakage Treatments</li>
                <li>Waterproofing and Linings</li>
                <li>Historic Building Restoration</li>
                <li>Space Optimization</li>
              </ul>
            </div>
            
            <div className="service-box">
              <div className="service-icon">
                <FaChartLine />
              </div>
              <h3>Project Management</h3>
              <p>
                Our comprehensive project management services ensure that your construction project is completed on time and within budget.
              </p>
              <ul className="service-features">
                <li>Schedule Development</li>
                <li>Budget Management</li>
                <li>Quality Control</li>
                <li>Contractor Coordination</li>
                <li>Risk Management</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      
      {/* Additional Services */}
      <section className="section additional-services">
        <div className="container">
          <h2 className="section-title">Specialized Services</h2>
          <div className="services-grid">
            <div className="service-box">
              <div className="service-icon">
                <FaPencilRuler />
              </div>
              <h3>Architecture & Design</h3>
              <p>
                Our architectural design services combine creativity and functionality to create spaces that are both beautiful and practical.
              </p>
            </div>
            
            <div className="service-box">
              <div className="service-icon">
                <FaHandshake />
              </div>
              <h3>Construction Consulting</h3>
              <p>
                Benefit from our expertise with our construction consulting services, helping you make informed decisions throughout your project.
              </p>
            </div>
            
            <div className="service-box">
              <div className="service-icon">
                <FaTruckMoving />
              </div>
              <h3>Site Preparation</h3>
              <p>
                We handle all aspects of site preparation, from demolition to grading, ensuring a solid foundation for your construction project.
              </p>
            </div>
            
            <div className="service-box">
              <div className="service-icon">
                <FaLeaf />
              </div>
              <h3>Sustainable Building</h3>
              <p>
                Our sustainable building practices incorporate eco-friendly materials and energy-efficient designs for a greener future.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Service Process */}
      <section className="section service-process">
        <div className="container">
          <h2 className="section-title">Our Process</h2>
          <div className="process-grid">
            <div className="process-step">
              <div className="step-number">01</div>
              <h3>Consultation</h3>
              <p>
                We begin with a thorough consultation to understand your needs, preferences, and budget, establishing clear objectives for your project.
              </p>
            </div>
            
            <div className="process-step">
              <div className="step-number">02</div>
              <h3>Design & Planning</h3>
              <p>
                Our design team works closely with you to develop plans that align with your vision, incorporating functional and aesthetic considerations.
              </p>
            </div>
            
            <div className="process-step">
              <div className="step-number">03</div>
              <h3>Estimation & Approval</h3>
              <p>
                We provide detailed cost estimates and project timelines for your approval, ensuring transparency throughout the planning process.
              </p>
            </div>
            
            <div className="process-step">
              <div className="step-number">04</div>
              <h3>Construction</h3>
              <p>
                Our skilled team executes the project with precision, adhering to the highest standards of quality and safety throughout the construction phase.
              </p>
            </div>
            
            <div className="process-step">
              <div className="step-number">05</div>
              <h3>Quality Assurance</h3>
              <p>
                We conduct thorough quality checks at every stage to ensure that the work meets our exacting standards and your expectations.
              </p>
            </div>
            
            <div className="process-step">
              <div className="step-number">06</div>
              <h3>Final Delivery</h3>
              <p>
                Once construction is complete, we walk you through the finished project, addressing any concerns before final handover.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Start Your Construction Project?</h2>
            <p>Contact us today for a consultation and free quote. Our team is ready to bring your vision to life with expertise and dedication.</p>
            <a href="/contact" className="btn btn-large">Get a Free Quote</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
